import styled from '@emotion/styled'

import { spacing } from 'main/ui'

export const Container = styled.div`
  align-items: center;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  margin-right: ${spacing.majorScale(2)}px;

  > :not(:last-child) {
    margin-right: ${spacing.majorScale(1)}px;
  }
`
